import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

class ActivityController extends Controller {
  connect() {
    this.toggleActivityOptions();
  }

  onActivityChange() {
    this.toggleActivityOptions();
  }

  isChecked() {
    return this.optionTarget.checked;
  }

  toggleActivityOptions() {
    this.optionsTarget.toggleAttribute('hidden', !this.isChecked());

    const requiredFields = toArray(this.optionsTarget.querySelectorAll('[data-required]'));

    if (requiredFields.length) {
      requiredFields.forEach((field) => field.toggleAttribute('required', this.isChecked()));
    }
  }
}

ActivityController.targets = [
  'option',
  'options',
];

export default ActivityController;
